import { residenceTargetRoles } from '@/mocks/corporateResidenceData';
import { useTranslation } from 'react-i18next';

export default function TargetRoles() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          {String(t('corporateResidence.roles.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('corporateResidence.roles.title')}
          </h2>
          {String(t('corporateResidence.roles.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-5"></div>
          {String(t('corporateResidence.roles.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[600px] mx-auto">{__s}</p>))}
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {residenceTargetRoles.map((_role, idx) => (
            <span
              key={idx}
              className="inline-block px-5 py-2.5 bg-background-100/60 border border-background-200/60 text-[15px] text-foreground-700 tracking-[0.05em]"
            >
              {t(`corporateResidence.roles.r${idx + 1}`)}
            </span>
          ))}
        </div>

        <div className="bg-background-100/60 border border-background-200/60 p-6 text-center max-w-[500px] mx-auto">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-user-line text-accent-500"></i>
            </div>
            <span className="text-[15px] text-foreground-800 tracking-[0.05em] font-medium">
              {t('corporateResidence.roles.capacity')}
            </span>
          </div>
          {String(t('corporateResidence.roles.capacityNote')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed">{__s}</p>))}
        </div>
      </div>
    </section>
  );
}
